import { render, staticRenderFns } from "./course-tab.vue?vue&type=template&id=6724fd8c&scoped=true"
import script from "./course-tab.vue?vue&type=script&lang=js"
export * from "./course-tab.vue?vue&type=script&lang=js"
import style0 from "./course-tab.vue?vue&type=style&index=0&id=6724fd8c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6724fd8c",
  null
  
)

export default component.exports